export function getIframeFromUrl(url: string) {
  return `<iframe class="airtable-embed" src="${url}" frameborder="0" onmousewheel="" width="100%" height="100%" style="background: transparent; border: 1px solid #ccc"/>`;
}

export function getAddCompanyIframe() {
  return getIframeFromUrl(
    'https://airtable.com/embed/shrs4oAarcCiuwmn0?backgroundColor=cyan'
  );
}
